import styled from 'styled-components'

type Color = 'green' | 'blue'
export type CurrencyPlaceholderProps = {
  color: Color
}

export const CurrencyPlaceholder: React.FC<CurrencyPlaceholderProps> = ({
  color,
}) => {
  return (
    <Root>
      <Circle $color={color}>?</Circle>
    </Root>
  )
}

const GRADIENT_MAP: Record<Color, string> = {
  blue: `linear-gradient(180deg, #6ED3E5 0%, #338DE1 100%)`,
  green: `linear-gradient(180deg, #6EE583 0%, #46E133 100%)`,
}

const Root = styled.div`
  height: 24px;
  width: 24px;
  padding: 1px;
  border-radius: 50%;

  border: 1px solid var(--background-7);
`

const Circle = styled.div<{ $color: Color }>`
  height: 100%;
  width: 100%;
  border-radius: 50%;
  color: var(--appearance-1);
  background: ${({ $color }) => GRADIENT_MAP[$color]};

  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
`
